import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import CookieConsent from "@/components/layout/CookieConsent";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";
import Consultation from "@/pages/Consultation";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import NotFound from "@/pages/NotFound";
import LandingPage from "@/pages/LandingPage";
import ClientDashboard from "@/pages/client/ClientDashboard";
import AuthCallback from "@/pages/AuthCallback";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminContent from "@/pages/admin/AdminContent";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAudit from "@/pages/admin/AdminAudit";

function SessionGuard({ children }) {
  const location = useLocation();
  // Process the Emergent OAuth callback before any protected route runs.
  if (location.hash && location.hash.includes("session_id=")) return <AuthCallback />;
  return children;
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <CookieConsent />
            <SessionGuard>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lp/youtube-promotion" element={<LandingPage />} />
              <Route path="/get-started" element={<LandingPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/consultation" element={<Consultation />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy-policy" element={<Legal />} />
              <Route path="/terms" element={<Legal />} />
              <Route path="/refund-policy" element={<Legal />} />
              <Route path="/disclaimer" element={<Legal />} />
              <Route path="/cookie-policy" element={<Legal />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route path="/dashboard" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="campaigns" element={<AdminCampaigns />} />
                <Route path="inbox" element={<AdminInbox />} />
                <Route path="services" element={<AdminContent />} />
                <Route path="pricing" element={<AdminContent />} />
                <Route path="faqs" element={<AdminContent />} />
                <Route path="testimonials" element={<AdminContent />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="audit" element={<AdminAudit />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
            </SessionGuard>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
